import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VipProductCard from "./VipProductCard";
import {useNavigate} from "react-router-dom";
import ApiService from "../../api/ApiService";
import PayModal from "../../components/PayModal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleExclamation, faNoteSticky} from "@fortawesome/free-solid-svg-icons";

const MembershipPlans = () => {

    const navigate = useNavigate();
    const api = new ApiService();
    const [productList, setProductList] = React.useState([]);
    const [payModalVisible, setPayModalVisible] = React.useState(false);
    const [selectedVipItem, setSelectedVipItem] = React.useState(null);

    React.useEffect(() => {
        getProductList();
    }, [])

    async function getProductList() {
        var result = await api.productList(0);
        if (Array.isArray(result.data)) {
            setProductList(result.data);
        } else {
            setProductList([]);
        }
    }

    return (
        <Container className="">
            <Row className={"mb-3 mt-3"}>
                <Col md={12} style={{textAlign: 'start',color: '#ffffff',background: 'rgba(255,255,255,0.3)', padding: '10px 20px',borderRadius: '10px',fontSize: '16px'}}>
                    <FontAwesomeIcon icon={faCircleExclamation} style={{marginRight: '4px',color: '#02C8E3'}} size={'1x'}/>
                    <span>基于产品的特殊性，一旦您完成付款，本产品不支持退订。购买前请仔细阅读产品权益</span>
                </Col>
            </Row>
            <Row>
                {productList?.map((product, index) => (
                    <Col md={6} lg={3}>
                        <VipProductCard key={index} item={product} toPay={(item)=>{
                            setSelectedVipItem(item)
                            setPayModalVisible(true)
                        }}/>
                    </Col>
                ))}
            </Row>
            <div style={{justifySelf: 'left', display: 'flex',}}>
                <button className="mt-3 mb-3"
                        onClick={() => {
                            navigate('/VipChargingList')
                        }}
                        style={{
                            background: 'transparent',
                            border: 'solid 1px #606060',
                            borderRadius: '360px',
                            color: '#B4BFC5',
                            fontSize: '16px',
                            padding: '9px 18px'
                        }}>会员开通记录
                </button>
            </div>
            <PayModal visible={payModalVisible} product={selectedVipItem} payMethod={null}  onClose={() => setPayModalVisible(false)}></PayModal>
        </Container>
    );
};

export default MembershipPlans;